import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Segment, Dimmer, Loader, Message, Header, Label, Table, Icon, Button,
} from "semantic-ui-react";
import { fetchVodafoneOrders } from "../libs/requests/vodafoneOrderSearch";
import moment from "moment";

const STATUS_COLOUR = {
  Pending: "yellow", Accepted: "green", Failed: "red",
  Active: "teal", Live: "teal", Completed: "green",
};

function Field({ label, value }) {
  if (!value) return null;
  return (
    <Table.Row>
      <Table.Cell width={5}><strong>{label}</strong></Table.Cell>
      <Table.Cell>{value}</Table.Cell>
    </Table.Row>
  );
}

export default function ViewVodafoneOrder() {
  const { reference } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchVodafoneOrders(reference)
      .then(results => {
        const match = Array.isArray(results)
          ? results.find(o => o.reference?.toLowerCase() === reference.toLowerCase())
          : null;
        if (match) setOrder(match);
        else setError(`No Vodafone order found for reference: ${reference}`);
      })
      .catch(() => setError("Failed to load order details."))
      .finally(() => setLoading(false));
  }, [reference]);

  if (loading) {
    return (
      <Segment>
        <Dimmer active inverted><Loader>Loading order…</Loader></Dimmer>
      </Segment>
    );
  }

  if (error) {
    return <Message negative><Message.Header>{error}</Message.Header></Message>;
  }

  return (
    <Segment>
      <Button as={Link} to="/LandingPage" icon labelPosition="left" size="small" style={{ marginBottom: "16px" }}>
        <Icon name="arrow left" /> Back to Orders
      </Button>

      <Header as="h2">
        Vodafone Order — {order.reference}
        <Label
          color={STATUS_COLOUR[order.status] ?? "grey"}
          style={{ marginLeft: "12px", verticalAlign: "middle" }}
        >
          {order.status}
        </Label>
      </Header>

      <Table definition celled>
        <Table.Body>
          <Field label="Reference"         value={order.reference} />
          <Field label="Supplier Reference" value={order.supplierReference} />
          <Field label="Supplier"           value={order.supplier} />
          <Field label="Product"            value={order.productDescription} />
          <Field label="Product Code"       value={order.productCode} />
          <Field label="Feature Code"       value={order.featureCode} />
          <Field label="Care Level"         value={order.careLevel} />
          <Field label="Order Type"         value={order.orderType} />
          <Field label="Address"            value={order.address} />
          <Field label="Activation Date"
            value={order.activationDate ? moment(order.activationDate).format("DD/MM/YYYY") : null} />
          <Field label="Ordered By"         value={order.orderedBy} />
          <Field label="Contact Name"       value={order.contactName} />
          <Field label="Contact Phone"      value={order.contactPhone} />
          <Field label="Appointment Date"
            value={order.appointmentDate ? moment(order.appointmentDate).format("DD/MM/YYYY") : null} />
          <Field label="Appointment Slot"   value={order.appointmentTimeSlot} />
          <Field label="Appointment Ref"    value={order.appointmentReference} />
          <Field label="Appointment Type"   value={order.appointmentType} />
        </Table.Body>
      </Table>

      {order.updates?.length > 0 && (
        <>
          <Header as="h4">Updates</Header>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Timestamp</Table.HeaderCell>
                <Table.HeaderCell>Message</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {order.updates.map((u, i) => (
                <Table.Row key={i}>
                  <Table.Cell collapsing>{u.timestamp}</Table.Cell>
                  <Table.Cell>{u.message}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </>
      )}
    </Segment>
  );
}
